import {useFormContext} from '@yandex-delivery/nlf-form/v2'

export function useDeliveryType() {
  const {watch} = useFormContext()

  return watch('deliveryType')
}
